import { PAGE_SIZE } from '@workspace/lib/document-hub-utils';
import { DocumentHubSkeleton } from '@workspace/ui/Skeleton/document-hub/DocumentHubSkeleton';
import { DocumentHubLoadMoreControls } from './DocumentHubLoadMoreControls';
import { HubItem, Section } from '@workspace/interfaces';
import { DocumentHubItem } from './DocumentHubItem';

interface DocumentHubSectionContentProps {
  section: Section;
  itemsToShow: HubItem[];
  hasAnyData: boolean;
  isLoading: boolean;
  showControls: boolean;
  onLoadMore: (section: Section) => void;
  onShowAll: (section: Section) => void;
  downloadCTA?: string;
  viewCTA?: string;
}

const compoundKey = (panelId: string, fileId: string) => `${panelId}:${fileId}`;

export function DocumentHubSectionContent({
  section,
  itemsToShow,
  hasAnyData,
  isLoading,
  showControls,
  onLoadMore,
  onShowAll,
  downloadCTA,
  viewCTA,
}: DocumentHubSectionContentProps) {
  return (
    <>
      {!hasAnyData && isLoading ? (
        <DocumentHubSkeleton itemsCount={PAGE_SIZE} />
      ) : (
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-5 lg:gap-y-6 gap-4">
          {itemsToShow.map((item) => (
            <li key={compoundKey(section.id, String(item.id))}>
              <DocumentHubItem item={item} downloadCTA={downloadCTA} viewCTA={viewCTA} />
            </li>
          ))}
        </ul>
      )}

      {isLoading && hasAnyData ? (
        <div className="md:mt-8 mt-4">
          <DocumentHubSkeleton itemsCount={PAGE_SIZE} />
        </div>
      ) : (
        <DocumentHubLoadMoreControls
          section={section}
          showControls={showControls}
          onLoadMore={onLoadMore}
          onShowAll={onShowAll}
        />
      )}
    </>
  );
}
